import type { PalantirFilterOption } from './filter-modal.type';

export function normalizeString(string: string) {
  return string
    .normalize('NFD')
    .replaceAll(/[\u0300-\u036F]/g, '')
    .toLowerCase();
}

export function removeNormalizedFromOption(option: PalantirFilterOption) {
  const clone = structuredClone(option);
  Reflect.deleteProperty(clone, 'normalized');
  return clone;
}

export function createSimpleHash(str: string): string {
  let hash = 0;
  for (let idx = 0, len = str.length; idx < len; idx++) {
    const chr = str.codePointAt(idx);
    if (chr === undefined) {
      continue;
    }

    hash = (hash << 5) - hash + chr;
    hash = Math.trunc(hash);
  }

  return Math.abs(hash).toString(16);
}
